import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import "./getintouch-uploaddoc.scss";
import { useSelector } from "react-redux";
import docUploadIcon from "../../../assets/doc_upload.png";

const GetInTouchDocUpload = (props) => {
  const { addFilesIntoList, toRemoveFile, setDocErrorMsg, setShowDocError } =
    props;
  const fileSizeLimit = 15 * 1024 * 1024; //15mb limit as per iSMRT validation
  const [documentStatus, setDocumentStatus] = useState({ documentlist: [] });
  // eslint-disable-next-line no-unused-vars
  const { uploadDocFetching, uploadDocData } = useSelector(
    // eslint-disable-line no-unused-vars
    (state) => state.uploadDoc, // eslint-disable-line
  );
  const [selectedFileSize, setSelectedFileSize] = useState(0);

  const onInputClick = (event) => {
    event.target.value = "";
  };

  useEffect(() => {
    // Using this for removing file
    if (toRemoveFile) {
      const newFiles = documentStatus.documentlist.filter((file) => {
        return toRemoveFile.name !== file;
      });
      setDocumentStatus({ documentlist: newFiles });
      setSelectedFileSize(selectedFileSize - toRemoveFile?.size);
    }
  }, [toRemoveFile]);

  const uploadFile = (e) => {
    const file = e?.target?.files[0];
    if (!file) return;
    //Checking file size before adding
    if (selectedFileSize + file.size >= fileSizeLimit - 100) {
      setShowDocError(true);
      setDocErrorMsg("File size limit reached, required less than 15Mb");
      return;
    }
    // Checking for file extension
    const extension = file.type;
    if (
      extension === "application/pdf" ||
      extension === "application/doc" ||
      extension === "application/docx" ||
      extension === "application/msword" ||
      extension ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      extension === "image/png" ||
      extension === "image/jpeg" ||
      extension === "image/jpg" ||
      extension === "text/plain"
    ) {
      if (documentStatus?.documentlist.includes(file.name)) {
        setShowDocError(true);
        setDocErrorMsg("File name already exist");
      } else {
        // Use FileReader to validate the file content
        const reader = new FileReader();

        reader.onload = (event) => {
          const arrayBuffer = event.target.result;
          const uint = new Uint8Array(arrayBuffer);
          const bytes = uint.subarray(0, 4); // Read the first 4 bytes
          let header = "";
          for (let i = 0; i < bytes.length; i++) {
            header += bytes[i].toString(16); // Convert bytes to hex
          }
          // Check file signature (magic numbers)

          const validSignatures = {
            pdf: "25504446", // PDF
            png: "89504e47", // PNG
            jpg: "ffd8ffe0", // JPG
            jpeg: "ffd8ff", // JPEG
            doc: "d0cf11e0", // DOC (older MS Word)
            docx: "504b", // DOCX (ZIP-based format)
            txt: "efbbbf", // UTF-8 text file (optional)
            txt2: "4c6f", // xml (EBCDIC) text file
          };

          const isValidFile = Object.values(validSignatures).some(
            (signature) => {
              return header.startsWith(signature);
            },
          );

          if (!isValidFile) {
            setShowDocError(true);
            setDocErrorMsg("Invalid file type. Please upload a valid file.");
            return;
          }

          // If valid, proceed with the upload

          setSelectedFileSize(selectedFileSize + file.size);

          addFilesIntoList(file);
          setDocumentStatus((prevState) => ({
            documentlist: [...prevState.documentlist, file.name],
          }));
        };

        reader.readAsArrayBuffer(file); // Read the file as an ArrayBuffer
      }
    } else {
      setShowDocError(true);
      setDocErrorMsg("Incorrect file type");
    }
  };

  return (
    <div className="document-upload-modal-container">
      <Col xs={12}>
        <Card className="status-card pt-4">
          <Card.Body className="p-0">
            {uploadDocFetching ? (
              <div className="upload-doc-loader"></div>
            ) : (
              <Row>
                <div>
                  <Col xs={12} className="mt-3" align="center">
                    <img
                      src={docUploadIcon}
                      style={{ height: 36, width: 48 }}
                    />
                  </Col>
                  <Col xs={12} className="mt-3" align="center">
                    <span className="upload-filetype">
                      Files supported JPG, PNG, PDF, DOC, DOCX, TEXT
                    </span>
                  </Col>
                  <Col xs={12} className="mt-3" align="center">
                    <label htmlFor="files" className="upload-btn">
                      <span className="upload-label">
                        <a>Browse files</a>
                      </span>
                    </label>
                  </Col>
                  <Col xs={12} className="mt-3" align="center">
                    <span className="upload-filetype">
                      Maximum size of total files: 15Mb
                    </span>
                  </Col>
                </div>
              </Row>
            )}

            <input
              id="files"
              onChange={uploadFile}
              onClick={onInputClick}
              name="memberdoc"
              accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/plain"
              style={{ visibility: "hidden" }}
              type="file"
            />
          </Card.Body>
          <Card.Footer className="upload-footer mt-4">
            {!uploadDocFetching ? <></> : ""}
          </Card.Footer>
        </Card>
      </Col>
    </div>
  );
};

export default GetInTouchDocUpload;
